import c from "../components/etc/Const";

export const LOAD_BIDIB = 'LOAD_BIDIB';
//export const LOAD_BIDIB = createAction('LOAD_BIDIB')
export function loadBidib(json) {
    return {
        type: LOAD_BIDIB,
        data: json
    }
}

export const UPDATE_BIDIB = 'UPDATE_BIDIB';

export function updateBidib(json) {
    return {
        type: UPDATE_BIDIB,
        data: json
    }
}

export const LOAD_PLAN = 'LOAD_PLAN';
//export const LOAD_BIDIB = createAction('LOAD_BIDIB')
export function loadPlan(json) {
    return {
        type: LOAD_PLAN,
        data: json
    }
}

export const UPDATE_PLAN = 'UPDATE_PLAN';

export function updatePlan(json) {
    return {
        type: UPDATE_PLAN,
        data: json
    }
}

export const SET_EDITMODE = 'SET_EDITMODE';
export function setEditmode(json) {
    return {
        type: SET_EDITMODE,
        data: json
    }
}

export const SET_LCCONTAINER = 'SET_LCCONTAINER';
export function setLccontainer(json) {
    return {
        type: SET_LCCONTAINER,
        data: json
    }
}

export const LC_SELECT = 'LC_SELECT';
export function selectLc(json) {
    return {
        type: LC_SELECT,
        data: json
    }
}

export const ITEM_SELECT = 'ITEM_SELECT';
export function selectItem(json) {
    return {
        type: ITEM_SELECT,
        data: json
    }
}

export const NODE_SELECT = 'NODE_SELECT';
export function selectNode(json) {
    return {
        type: NODE_SELECT,
        data: json
    }
}

export const GUI_STATE = 'GUI_STATE';
export function setGuiState(json) {
    return {
        type: GUI_STATE,
        data: json
    }
}

export const SIGNAL_CLICK = 'SIGNAL_CLICK';
export function signalClick(json) {
    return {
        type: SIGNAL_CLICK,
        sg: json
    }
}

function _fetch(path) {
    const myHeaders = new Headers();
    myHeaders.append('Access-Control-Allow-Origin', '*');
    myHeaders.append('referrerPolicy', 'no-referrer');

    return function (dispatch) {
        fetch("http://" + window.location.hostname + ":" + c.PORT + "/rest/" + path,
            {myHeaders})
            .then(
                response => response.json(),
                error => console.log('An error occurred. (/rest/items)', error)
            )
            .then(json => {
                    if (path === 'bidib') {
                        dispatch(loadBidib(json))
                    }
                    else {
                        dispatch(loadPlan(json))
                    }
                }
            )
    }
}

export function fetchBidib() {
    return _fetch('bidib')
}

export function fetchPlan() {
    return _fetch('plan')
}

export function fetchScenario(path) {
    return _fetch(path)
}